import axios from "axios";
import React, { useEffect, useState } from "react";


import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';



const getBarColor = (growth) => {
  if (growth === null || growth === undefined) return "#9CA3AF"; // gray
  if (growth >= 0) return "#22C55E"; // green
  return "#EF4444"; // red
};

const TodaysBranchSales = ({ endpoint }) => {


  let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"

  // let dummy = [
  //   {
  //     Branch_ID: "MAIN      ",
  //     Branch_Name: "HO - STORE",
  //     CashSale: 61740,
  //     CreditSale: 4000,
  //     CashReturn: 500,
  //     CreditReturn: 300,
  //     NetAmount: 6389
  //   }
  // ]
  const [trendData, setTrendData] = useState([])
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState([]);
  const [selectedBranchCode, setSelectedBranchCode] = useState([]);

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  const todayDate = getTodayDate();

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await axios.get(
          `https://cubixweberp.com:213/api/MasterCount/${company_code_from_local_storage}/BRANCH/ADMIN/-`
        );
        const data = response.data;
        const branchArray = Array.isArray(data) ? data : [data];
        console.log('branchArray', branchArray)
        setBranches(branchArray);

        // Automatically select the first branch
        if (branchArray.length > 0) {
          //   setSelectedBranch(branchArray[0].DEPTNO);
          setSelectedBranch(branchArray[0]);
        }
      } catch (error) {
        console.error("Failed to fetch branches", error);
      }
    };

    fetchBranches();
  }, []);

  useEffect(() => {
    console.log('selectedBranch', selectedBranch)
    if (selectedBranch) {
      fetchTrendData(selectedBranch);
    }
  }, [selectedBranch]);


  useEffect(() => {
    console.log('selectedbranchCode', selectedBranchCode)

    const selected = branches?.find(
      (branch) => branch.DEPTNO === selectedBranchCode
    );
    setSelectedBranch(selected);
    console.log('selected', selected)
  }, [selectedBranchCode])

  const fetchTrendData = async (selectedBranch) => {
    try {

      let fromDate = "2024-01-01"
        if(endpoint == "Todays_Sales_Branch"){
            fromDate = todayDate
        }
      const response = await axios.get(
        `https://cubixweberp.com:213/api/HRDashboard/${company_code_from_local_storage}/${selectedBranch.DEPTNO}/${endpoint}/${fromDate}/${todayDate}/-/-/-/-/-`
      );
      const data = response.data || [];

      console.log("data >>. todays", data)
      setTrendData(data);
    } catch (err) {
      console.error("Error while fetching financial data", err);
    }
  }


  return (
    <div className="w-full h-[300px] rounded px-4">


      <div className="flex justify-between items-center mb-2">
        <div className="flex justify-left gap-4 items-center mb-2">

          {selectedBranch && (
            <div className="mt-2 text-sm text-gray-700">
              Selected Branch:{" "}
              <strong>
                {selectedBranch.deptnodesc} ({selectedBranch.DEPTNO})
              </strong>
            </div>
          )}
        </div>

        <select
          value={selectedBranch?.DEPTNO || ""}
          onChange={(e) => setSelectedBranchCode(e.target.value)}
          className="border border-gray-300 rounded px-2 py-1 text-sm"
        >
          {branches?.map((branch) => (
            <option key={branch.DEPTNO} value={branch.DEPTNO}>
              {branch.deptnodesc}
            </option>
          ))}
        </select>
      </div>

      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          width={500}
          height={300}
          data={trendData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="CashSale" fill="#8884d8"  />
          <Bar dataKey="CashReturn" fill="#82ca9d"  />
          <Bar dataKey="CreditSale" fill="#7c7c7c"  />
          <Bar dataKey="CreditReturn" fill="#f87171"  />
        </BarChart>
      </ResponsiveContainer>

    </div>
  );
};

export default TodaysBranchSales;